import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowLinkUI from '../../../widgets/layout/LRTableRowLinkUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './BankTxnList.css'

// Unused
const BankTxnListUI = ({context, messageList, txnList,
    alphaSort, timeSort, searchFilter,
    onRefreshClick, onAlphaSortClick, onTimeSortClick,
    onSearchFilterChange
  }) =>
  <div className='txn_b_txns g_m_top_100'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          alphaSort={alphaSort}
          timeSort={timeSort}
          onRefreshClick={onRefreshClick}
          onAlphaSortClick={onAlphaSortClick}
          onTimeSortClick={onTimeSortClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        txnList.map((txn, i) =>
          <TxnRowUI key={i} context={context} txn={txn} />
        )
      }
    </LRTableBodyUI>

  </div>

const TxnRowUI = ({context, txn, messageList}) =>
  <LRTableRowLinkUI
    context={context}
    to={`/txns/${txn.transactionId}/tasks`}
    left={<RowLeftUI context={context} txn={txn} />}
    right={<RowRightUI context={context} txn={txn} />}
  />

const RowLeftUI = ({context, txn}) =>
  <div className='g_flex_v'>
    <span className='g_muted'>
      {txn.transactionDateF}
    </span>
    <span>{txn.payee}</span>
    <span>{txn.description}</span>
  </div>

const RowRightUI = ({context, txn}) =>
  <div className='g_flex_v g_text_right'>
    <table><tbody>
      {/*
        bill.taxList.map((tax, j) =>
          <tr key={j}>
            <td className='g_no_wrap_2'>{tax.name}</td>
            <td className='g_text_right'>{tax.amountF2}</td>
          </tr>
        )
      */}
      <tr><td>Total</td><td className='g_text_right'>{txn.amountF2}</td></tr>
      {
        txn.tdsAmountF2 &&
        <tr><td>TDS {txn.tdsSection} @{txn.tdsRate}%</td>
        <td className='g_text_right'>{txn.tdsAmountF2}</td></tr>
      }
    </tbody></table>
  </div>

const ActionLeftUI = ({context, messageList, alphaSort, timeSort,
    onRefreshClick, onAlphaSortClick, onTimeSortClick
  }) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    <IconButtonUI messageList={messageList} icon='icon-sort-alpha-asc' selected={alphaSort} onClick={onAlphaSortClick} labelKey='c_sort_alpha' />
    <IconButtonUI messageList={messageList} icon='icon-clock-o' selected={timeSort} onClick={onTimeSortClick} labelKey='c_sort_time' />
  </div>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange
  }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default BankTxnListUI
